import React from "react";

const PreviewContent = (props) => {
  const { content } = props;

  return (
    <div className="section-article-box no-scroll">
      <div className="article-view-body">
        <div
          className="article-view-content"
          dangerouslySetInnerHTML={{
            __html: `${content}`,
          }}
          style={{
            lineHeight: "2rem",
          }}
        />
      </div>
    </div>
  );
};

export default PreviewContent;
